module.exports = __webpack_public_path__ + "15c05fcf6ae5e081d55c7602e6f26f5c.png";